export default __webpack_public_path__ + "static/rio-17bd72fa2548bd5bdb6dfd6cb0130ef5.png";